import { HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutStatusAddOrder extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelHeadingText: Label;
    panelSaveStatus: Panel;
    textboxOrderNumber: Textbox;
}
